import { createElement, useState, useCallback, useEffect } from "react";
import './index.scss';
import { Wheel } from './wheel';
import classNames from "classnames";
import { convertDateToStringArray, generateDatePickerColumns } from "./datePicker-utils";
import { generateColumnsExtend } from './columns-extend';
const ColorfulDatePicker = function ColorfulDatePicker({ visible, min, max, precision, defaultValue, unit, title, onConfirm, ...otherProps }) {
    const classPrefix = `au-date-picker`;
    const [isVisible, setIsVisible] = useState(false);
    const [innerValue, setInnerValue] = useState();
    const [precisionUnit, setPrecisionUnit] = useState(precision);
    const [columnDatas, setColumnDatas] = useState([]);
    const classString = classNames('au-popup-picker', {
        [`${classPrefix}-active`]: isVisible,
    });
    const _otherProps = otherProps || {};
    const handleSelect = useCallback((val, index) => {
        const inner = innerValue?.slice();
        if (inner) {
            inner[index] = val;
            setInnerValue(inner);
        }
    }, [innerValue]);
    useEffect(() => {
        const thisYear = new Date().getFullYear();
        const minDate = min ? new Date(min) : new Date(new Date().setFullYear(thisYear - 10));
        const maxDate = max ? new Date(max) : new Date(new Date().setFullYear(thisYear + 10));
        const columns = generateDatePickerColumns(innerValue, minDate, maxDate, precisionUnit, unit);
        const extend = generateColumnsExtend(columns, innerValue);
        const columnDatas = extend.columns;
        setColumnDatas(columnDatas);
    }, [innerValue, min, max, precisionUnit, unit]);
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm(innerValue);
        }
        setIsVisible(false);
    };
    useEffect(() => {
        setIsVisible(visible);
    }, [visible]);
    useEffect(() => {
        if (precision) {
            setPrecisionUnit(precision);
        }
        else {
            setPrecisionUnit('day');
        }
    }, [precision]);
    useEffect(() => {
        const date = defaultValue ? new Date(defaultValue) : new Date();
        const pickerValue = convertDateToStringArray(date, precisionUnit);
        window.setTimeout(() => {
            setInnerValue(pickerValue);
        }, 100);
    }, [precisionUnit, defaultValue]);
    return (createElement("div", { className: classString },
        createElement("div", { className: "au-mask" }),
        createElement("div", { className: classPrefix, ..._otherProps },
            createElement("div", { className: `${classPrefix}-header` },
                createElement("a", { role: 'button', className: `${classPrefix}-header-button`, onClick: () => {
                        setIsVisible(false);
                    } }, "\u53D6\u6D88"),
                createElement("div", { className: `${classPrefix}-header-title` }, title),
                createElement("a", { role: 'button', className: `${classPrefix}-header-button`, onClick: () => {
                        handleConfirm();
                    } }, "\u786E\u5B9A")),
            createElement("div", { className: `${classPrefix}-body` },
                createElement("div", { className: `${classPrefix}-view` },
                    columnDatas?.map((column, index) => (innerValue !== undefined &&
                        createElement(Wheel, { key: index, index: index, column: column, value: innerValue[index], onSelect: handleSelect, mouseWheel: true }))),
                    createElement("div", { className: `${classPrefix}-mask` },
                        createElement("div", { className: `${classPrefix}-mask-top` }),
                        createElement("div", { className: `${classPrefix}-mask-middle` }),
                        createElement("div", { className: `${classPrefix}-mask-bottom` })))))));
};
ColorfulDatePicker.displayName = 'ColorfulDatePicker';
export default ColorfulDatePicker;
